/**
 * Shell-side FR-A8 hook: map meta → verdict and re-tick wall clock.
 */
import { useMemo } from 'react';

import type { DatasetMeta } from '@meridian/contracts';

import { stalenessFromMeta } from './staleness-from-meta';
import { useNowTick } from './use-now-tick';

import type { StalenessVerdict } from './evaluate-staleness';

/**
 * `nowMs` is a real input to the memo, not a no-op dependency: TanStack Query
 * structural-shares equal meta payloads, so `meta` identity does not advance
 * on its own and the 36h / membership / frozen axes would otherwise freeze at
 * the verdict computed on first paint.
 */
export function useShellStaleness(meta: DatasetMeta | undefined): StalenessVerdict {
  const nowMs = useNowTick();
  return useMemo(() => stalenessFromMeta(meta, new Date(nowMs)), [meta, nowMs]);
}
